// import React from 'react';
import './hello-world-styles.css';

// TODO: Create your HelloWorld component here
// The component should display "Hello, World!" in a heading

const HelloWorld = () => {
  // Your implementation here
};

export default HelloWorld;
